var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apply-form-settings',{attrs:{"form-setting":_vm.applicationForm,"preloader":_vm.preloader,"view-button":false},on:{"update":_vm.updateSetting}})
}
var staticRenderFns = []

export { render, staticRenderFns }